import { layout } from "@demo-data/layout";
import { Box, Stack } from "@mui/material";

export default function Sidebar() {
  const { sidebar } = layout || {};
  return (
    <Stack
      sx={{
        width: "100%",
        pt: 4,
      }}
    >
      <Stack alignItems="center" spacing={2} width="35%">
        <Box
          sx={{
            width: "2px",
            height: 240,
            backgroundColor: (theme) => theme.palette.divider,
          }}
        />
        <Stack>
          {sidebar?.map((item) => (
            <Box
              component="a"
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={item.name}
              title={item.name}
              key={item.id}
              sx={{
                color: (theme) => theme.palette.text.primary,
                transition: "transform 0.3s ease, color 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px) rotate(6deg)",
                  color: "primary.main",
                },
              }}
            >
              {" "}
              {item.icon}
            </Box>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
